import React, { FC } from "react";

export const ListIcon:FC = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3076 46C36.0102 46 46.3076 35.7025 46.3076 23C46.3076 10.2975 36.0102 0 23.3076 0C10.6051 0 0.307617 10.2975 0.307617 23C0.307617 35.7025 10.6051 46 23.3076 46Z"
        fill="#384455"
      />
    </svg>
  );
};
